import cloneDeep from 'lodash.clonedeep';
import { AccessFunction, AdditionalMO } from 'data/accessFunction/accessFunction.types';

export function getDiameterAccessFunctions(accessFunctions: AccessFunction[]):{
  [ key: string]: AccessFunction
} {
  if (accessFunctions == null || !accessFunctions.length) {
    return {}
  }

  return cloneDeep(accessFunctions)
    .filter(isDiameterAf)
    .reduce((total, af) => ({
      ...total,
      [af.id as string]: af
    }), {});
}

export function isDiameterAf(accessFunction: AccessFunction): boolean {
  const moName = getAdditionalMoName(accessFunction?.dataInterfaces?.[0]?.additionalMOs);
  return moName.toLocaleLowerCase() === 'DIAMETER'.toLocaleLowerCase();
}

export function isDeletingAfLastDiameterAf(
  accessFunction: AccessFunction,
  diameterAfsMap: {[ key: string]: AccessFunction }
): boolean {

  const diameterAf = diameterAfsMap[accessFunction.id as string];
  const totalDiameterAfs = Object.keys(diameterAfsMap).length;

  return diameterAf != null && totalDiameterAfs === 1;
}

function getAdditionalMoName(additionalMOs?: AdditionalMO[]): string {
  if (additionalMOs == null || !additionalMOs?.length) {
    return '';
  }

  return additionalMOs[0]?.moName || '';
}
